import BaseClass from "../../util/BaseClass";
import Context from "../../context/Context";
import FieldNames from "../../aiim/datasets/FieldNames";
import OfficePlan from "./OfficePlan";
import Topic from "../../context/Topic";
import * as aiimUtil from "../../aiim/util/aiimUtil";
import * as transactions from "./transaction/transactions";
import * as val from "../../util/val";

/*
  Transactions

    addArea
    deleteArea
    updateArea

 */

export default class AreasTable extends BaseClass {

  table;

  _areasById;
  _hotDeskAreas;
  _hotelAreas;

  addArea(areaName,areaType,restricted) {
    const areaId = areaType+"-"+val.generateRandomId();
    const promise = new Promise((resolve,reject) => {
      transactions.addArea(areaType,areaId,areaName,restricted).then(() => {
        return this._refresh();
      }).then(() => {
        resolve();
      }).catch(ex =>  {
        reject(ex);
      })
    });
    return promise;
  }

  deleteArea(areaItem,deletePeopleData) {
    const promise = new Promise((resolve,reject) => {
      const f = aiimUtil.findField(this.table.fields,FieldNames.AREA_TYPE);
      const areaType = aiimUtil.getAttributeValue(areaItem.attributes,f.name);
      transactions.deleteArea(areaItem,areaType,deletePeopleData).then(() => {
        return this._refresh();
      }).then(() => {
        console.log("AreasTable deleteArea complete ................")
        resolve();
      }).catch(ex =>  {
        reject(ex);
      })
    });
    return promise;
  }

  updateArea(areaItem,areaName) {
    const promise = new Promise((resolve,reject) => {
      const f = aiimUtil.findField(this.table.fields,FieldNames.AREA_TYPE);
      const areaType = aiimUtil.getAttributeValue(areaItem.attributes,f.name);
      transactions.renameArea(areaItem,areaType,areaName).then(() => {
        return this._refresh();
      }).then(() => {
        resolve();
      }).catch(ex =>  {
        reject(ex);
      })
    });
    return promise;
  }

  updateAreaRestriction(areaItem,restricted) {
    const promise = new Promise((resolve,reject) => {
      const f = aiimUtil.findField(this.table.fields,FieldNames.AREA_TYPE);
      const areaType = aiimUtil.getAttributeValue(areaItem.attributes,f.name);
      transactions.updateAreaRestriction(areaItem,areaType,restricted).then(() => {
        return this._refresh();
      }).then(() => {
        resolve();
      }).catch(ex =>  {
        reject(ex);
      })
    });
    return promise;
  }

  // updateArea(areaItem,areaName) {
  //   const task = {
  //     areaItem: areaItem,
  //     areaName: areaName,
  //     isUpdateArea: true
  //   };
  //   return this._applyEdits(task);
  // }


  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

  // _applyEdits(task) {
  //   const promise = new Promise((resolve,reject) => {
  //     const table = this.table;
  //     const fields = table.fields;
  //     const oidField = table.objectIdField;
  //     const edit = {attributes: {}};
  //     let edits;
  //
  //     if (task.isAddArea) {
  //       officePlanUtil.addAttributeEdit(fields,edit.attributes,
  //         FieldNames.AREA_ID,task.areaId);
  //       officePlanUtil.addAttributeEdit(fields,edit.attributes,
  //         FieldNames.AREA_NAME,task.areaName);
  //       officePlanUtil.addAttributeEdit(fields,edit.attributes,
  //         FieldNames.AREA_TYPE,task.areaType);
  //       edits = {addFeatures: [edit]};
  //     } else if (task.isUpdateArea) {
  //       edit.attributes[oidField] = task.areaItem.attributes[oidField];
  //       officePlanUtil.addAttributeEdit(fields,edit.attributes,
  //         FieldNames.AREA_NAME,task.areaName);
  //       edits = {updateFeatures: [edit]};
  //     } else if (task.isDeleteArea) {
  //       edit.attributes[oidField] = task.areaItem.attributes[oidField];
  //       edits = {deleteFeatures: [edit]}
  //     }
  //
  //     const editOptions = {};
  //     if (table.gdbVersion) {
  //       editOptions.gdbVersion = table.gdbVersion;
  //     }
  //
  //     table.applyEdits(edits,editOptions).then(result => {
  //       return this._refresh();
  //     }).then(result => {
  //       resolve();
  //     }).catch(ex => {
  //       console.error("Error applying edits",ex);
  //       reject(ex);
  //     });
  //   });
  //   return promise;
  // }

  // _findAreaById(areas,areaId) {
  //   let found;
  //   if (areas) {
  //     const f = FieldNames.AREA_ID;
  //     areas.some(area => {
  //       if (areaId === aiimUtil.getAttributeValue(area.attributes,f)) {
  //         found = area;
  //         return true;
  //       }
  //       return false;
  //     })
  //   }
  //   return found;
  // }

  // getAreaName(areaId,areaType) {
  //   const i18n = Context.instance.i18n;
  //   const f = FieldNames.AREA_NAME;
  //   if (areaType === OfficePlan.SpaceAssignmentTypes.hotdesk) {
  //     const area = this._findAreaById(this._hotDeskAreas,areaId);
  //     if (area) return aiimUtil.getAttributeValue(area.attributes,f);
  //     return i18n.spaceplanner.assignmentType.hotdesk;
  //   } else if (areaType === OfficePlan.SpaceAssignmentTypes.hotel) {
  //     const area = this._findAreaById(this._hotelAreas,areaId);
  //     if (area) return aiimUtil.getAttributeValue(area.attributes,f);
  //     return i18n.spaceplanner.assignmentType.hotel;
  //   }
  // }
  //
  //

  getArea(areaId) {
    return (this._areasById && this._areasById[areaId]);
  }

  getAreaName(areaId,areaType) {
    const area = (this._areasById && this._areasById[areaId]);
    if (area) {
      return aiimUtil.getAttributeValue(area.attributes,FieldNames.AREA_NAME);
    }
    return "";
  }

  getAreaType(areaId) {
    const area = (this._areasById && this._areasById[areaId]);
    if (area) {
      return aiimUtil.getAttributeValue(area.attributes,FieldNames.AREA_TYPE);
    }
  }

  getRestrictedField() {
    if (this.table && this.table.fields) {
      let f = aiimUtil.findField(this.table.fields,FieldNames.AREAS_RESTRICTED);
      return f;
    }
    return null;
  }

  load(table) {
    const promise = new Promise((resolve,reject) => {
      this.table = table;
      table.when().then(() => {
        if (table.loadStatus === "failed") {
          console.error("AreasTable: load failed");
        }
        return this._refresh();
      }).then(() => {
        resolve();
      }).catch(ex => {
        console.error("Error loading AREAS table",ex);
        reject(ex);
      });
      table.load();
    });
    return promise;
  }

  makeDefinition(task) {
    const definition = {
      "name": "AREAS",
      "type": "Table",
      "capabilities": "Query,Editing,Create,Update,Delete,Sync",
      "fields": [
        {
          "alias": "OBJECTID",
          "defaultValue": null,
          "domain": null,
          "editable": false,
          "name": "OBJECTID",
          "nullable": false,
          "sqlType": "sqlTypeOther",
          "type": "esriFieldTypeOID"
        },
        {
          "alias": "Area Name",
          "defaultValue": "",
          "domain": null,
          "editable": true,
          "length": 500,
          "name": "area_name",
          "nullable": true,
          "sqlType": "sqlTypeNVarchar",
          "type": "esriFieldTypeString"
        },
        {
          "alias": "Area Type",
          "defaultValue": "",
          "domain": null,
          "editable": true,
          "length": 500,
          "name": "area_type",
          "nullable": true,
          "sqlType": "sqlTypeNVarchar",
          "type": "esriFieldTypeString"
        },
        {
          "alias": "Area ID",
          "defaultValue": "",
          "domain": null,
          "editable": true,
          "length": 500,
          "name": "area_id",
          "nullable": true,
          "sqlType": "sqlTypeNVarchar",
          "type": "esriFieldTypeString"
        }
      ],
      "htmlPopupType": "esriServerHTMLPopupTypeNone",
      "allowGeometryUpdates": true,
      "hasMetadata": false,
      "hasStaticData": false,
      "defaultVisibility": true,
      "isDataVersioned": false,
      "globalIdField": "",
      "hasZ": false,
      "copyrightText": "",
      "hasM": false,
      "displayField": "area_name",
      "standardMaxRecordCount": 32000,
      "hasAttachments": false,
      "typeIdField": "",
      "templates": [],
      "uniqueIdField": {
        "name": "OBJECTID",
        "isSystemMaintained": true
      },
      "maxRecordCountFactor": 1,
      "maxRecordCount": 2000,
      "description": "Area related attributes",
      "types": [],
      "tileMaxRecordCount": 8000,
      "objectIdField": "OBJECTID",
      "syncEnabled": true
    };
    return definition;
  }

  queryHotDeskAreas() {
    return this._refresh().then(()=>{
      return this._hotDeskAreas;
    })
  }

  queryHotelAreas() {
    return this._refresh().then(()=>{
      return this._hotelAreas;
    })
  }

  refresh() {
    if (!this.table) return Promise.resolve();
    const promise = new Promise((resolve,reject) => {
      const areasById = {};
      const table = this.table;
      const lib = Context.instance.lib;
      const url = Context.checkMixedContent(table.url+"/"+table.layerId);
      const queryTask = new lib.esri.QueryTask({url: url});
      const query = new lib.esri.Query();
      query.outFields = ["*"];
      query.where = "1=1";
      if (table.gdbVersion) query.gdbVersion = table.gdbVersion;
      queryTask.execute(query).then(result => {
        //console.log("AreasTable.query.result",result);
        let fields = (result.fields || table.fields);
        let hotDeskAreas = [], hotelAreas = [];
        let idField = aiimUtil.findField(fields,FieldNames.AREA_ID);
        let nameField = aiimUtil.findField(fields,FieldNames.AREA_NAME);
        let typeField = aiimUtil.findField(fields,FieldNames.AREA_TYPE);
        result.features.forEach(row => {
          //console.log(aiimUtil.getAttributeValue(row.attributes,nameField.name),row.attributes)
          const areaId = aiimUtil.getAttributeValue(row.attributes,idField.name);
          const areaType = aiimUtil.getAttributeValue(row.attributes,typeField.name);

          //console.log(aiimUtil.getAttributeValue(row.attributes,nameField.name),row.attributes)

          areasById[areaId] = row;
          if (areaType === OfficePlan.SpaceAssignmentTypes.hotdesk) {
            hotDeskAreas.push(row);
          } else if (areaType === OfficePlan.SpaceAssignmentTypes.hotel) {
            hotelAreas.push(row);
          }
        });
        this._sort(hotDeskAreas,nameField.name);
        this._sort(hotelAreas,nameField.name);
        this._areasById = areasById;
        this._hotDeskAreas = hotDeskAreas;
        this._hotelAreas = hotelAreas;
        Topic.publish(Topic.AreasRefreshed,{areasById: areasById});
        resolve();
      }).catch(ex => {
        console.error("Error querying AREAS table",ex);
        reject(ex);
      });
    });
    return promise;
  }

  _refresh() {
    return this.refresh();
  }

  _sort(areas,typeFieldName) {
    areas.sort((a,b) => {
      const aName = aiimUtil.getAttributeValue(a.attributes,typeFieldName) || "";
      const bName = aiimUtil.getAttributeValue(b.attributes,typeFieldName) || "";
      return aName.localeCompare(bName);
    })
  }

  _tmpData() {
    this._hotDeskAreas = [
      {
        attributes: {
          area_id: "hotdeskarea1",
          area_name: "Hot Desk Area 1",
          area_type: "hotdesk"
        }
      },
      {
        attributes: {
          area_id: "hotdeskarea2",
          area_name: "Hot Desk Area 2",
          area_type: "hotdesk"
        }
      }
    ];

    this._hotelAreas = [
      {
        attributes: {
          area_id: "hotelarea1",
          area_name: "Hotel Area 1",
          area_type: "hotel"
        }
      },
      {
        attributes: {
          area_id: "hotelarea2",
          area_name: "Hotel Area 2",
          area_type: "hotel"
        }
      }
    ];
  }

}
